export const isLocalStorageAvailable = () => 'localStorage' in window;
